import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@air/primitive-avatar";
import classNames from "classnames";
export const VideoTimestampMarker = (param)=>{
    let { className, onClick, style, userAvatar, userId, userInitials } = param;
    return /*#__PURE__*/ _jsxs("button", {
        className: classNames("group/video-timestamp-marker absolute inset-y-0", className),
        "data-testid": "VIDEO_TIMESTAMP_MARKER",
        onClick: onClick,
        style: style,
        children: [
            /*#__PURE__*/ _jsx(Avatar, {
                className: "pointer-events-auto absolute bottom-full left-1/2 -translate-x-1/2 -translate-y-2 cursor-pointer transition-all group-hover/video-timestamp-marker:ring group-hover/video-timestamp-marker:ring-white",
                "data-commenter-id": userId,
                "data-testid": "VIDEO_TIMESTAMP_MARKER_AVATAR",
                size: 24,
                src: userAvatar,
                text: userInitials,
                colorSeed: userId
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pointer-events-auto h-full w-0.5 bg-white transition-all group-hover/video-timestamp-marker:scale-x-150"
            })
        ]
    });
};
